import './index.css';
import { jsx } from 'react/jsx-runtime';
import { Children, isValidElement, useRef, useLayoutEffect, cloneElement } from 'react';
import classnames from 'classnames';
import { CheckableChip } from './CheckableChip.js';
import { CustomChip } from './CustomChip.js';
import { ScrollableContainer, useScrollContext } from '@hh.ru/magritte-ui-scrollable-container';
import '@hh.ru/magritte-common-use-disabled';
import './ChipContent-CS4N9BNF.js';
import '@hh.ru/magritte-ui-typography';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-icon/variants/icon';

var styles = {"container":"magritte-container___o9zaa_5-3-19","scrollable":"magritte-scrollable___GhecO_5-3-19","item":"magritte-item___LBqGp_5-3-19","nowrap":"magritte-nowrap___ioKUP_5-3-19"};

const isValidCheckableChipElement = (child) => isValidElement(child) && child.type === CheckableChip;
const isValidCustomChipElement = (child) => isValidElement(child) && child.type === CustomChip;
const ContainerItem = ({ children, }) => {
    const ref = useRef(null);
    const mouseDownRef = useRef(false);
    const { registerItem, removeItem, scrollToItem } = useScrollContext();
    useLayoutEffect(() => {
        registerItem(ref);
        return () => removeItem(ref);
    }, [registerItem, removeItem]);
    const handleClick = (event) => {
        children.props.onClick?.(event);
        scrollToItem(ref);
        mouseDownRef.current = false;
    };
    const handleFocus = (event) => {
        children.props.onFocus?.(event);
        // Проверка нужна для случая, когда клик длинный. Если не проверять, то произойдет скролл
        // и onClick не вызовется, потому что будет mousemove
        if (!mouseDownRef.current) {
            scrollToItem(ref);
        }
    };
    const handleMouseDown = (event) => {
        children.props.onMouseDown?.(event);
        mouseDownRef.current = true;
    };
    return (jsx("div", { ref: ref, className: styles.item, children: cloneElement(children, {
            onClick: handleClick,
            onFocus: handleFocus,
            onMouseDown: handleMouseDown,
        }) }));
};
const ChipsContainer = ({ children, noWrap = false, scrollable = false, ...containerProps }) => {
    const filteredChildren = Children.toArray(children).filter((child) => isValidCheckableChipElement(child) || isValidCustomChipElement(child));
    if (!scrollable) {
        return (jsx("div", { className: styles.container, "data-qa": "chips-container", ...containerProps, children: filteredChildren }));
    }
    return (jsx(ScrollableContainer, { disableButtons: !noWrap, "data-qa": "chips-container", ...containerProps, children: jsx("div", { className: classnames(styles.container, styles.scrollable, noWrap && styles.nowrap), children: Children.map(filteredChildren, (child) => (jsx(ContainerItem, { children: child }))) }) }));
};

export { ChipsContainer };
//# sourceMappingURL=ChipsContainer.js.map
